export function hasSelfHostedLicense() {
    return function (licenses) {
        return licenses.some((license) => {
            return (
                license.fontRights.web &&
                license.fontRights.web.qty &&
                license.fontRights.web.self_hosted
            );
        });
    };
}
